export enum EmailEntryFormNamesEnum {
  SUBJECT = 'Subject',
  RECIPIENTS = 'Recipients',
  CC = 'CC',
  TEMPLATE = 'Template',
  EMAIL_CONTENT = 'EmailContent',
  FORM_GROUP_NAME = 'Emails',
}
